import React from 'react';
import { Message } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const RequestApproveSuccess = () => {
  const intl = useIntl();
  return (
    <Message
      positive
      className="aridhia-request-approve-success"
      size="small"
      icon="thumbs up"
      header={intl.formatMessage({ id: 'access.request.approve.title' })}
      content={intl.formatMessage({ id: 'access.request.approve' })}
    />
  );
};

export default RequestApproveSuccess;
